import { useCallback, useState } from 'react'

import { type CatalogPermissionSecondaryCategoryConfig } from '@webapp/modules/purchasing/entities/CatalogPermissionSecondaryCategoryConfig'

export const useCatalogSecondaryCategoryAccessSection = () => {
  const [selectedSecondaryCategory, setSelectedSecondaryCategory] =
    useState<Nullable<CatalogPermissionSecondaryCategoryConfig>>(null)

  const selectedSecondaryCategoryId = selectedSecondaryCategory?.id ?? null

  const onSelectSecondaryCategory = useCallback(
    (secondaryCategory: CatalogPermissionSecondaryCategoryConfig) => {
      setSelectedSecondaryCategory(secondaryCategory)
    },
    []
  )

  const onCancel = useCallback(() => {
    setSelectedSecondaryCategory(null)
  }, [])

  return {
    states: {
      selectedSecondaryCategory,
      selectedSecondaryCategoryId,
    },
    commands: {
      onSelectSecondaryCategory,
      onCancel,
    },
  }
}
